export const addArticleToName = (name: string) => {
  // check if article a or an should be used before name
  const vowels = ['a', 'e', 'i', 'o', 'u']
  const firstLetter = name.charAt(0).toLowerCase()
  const article = vowels.includes(firstLetter) ? 'an' : 'a'
  return `${article} ${name}`
}
